import React from "react";
import { Locale } from "@linkfluence/models/locale";
import tr, { ITranslationValues, Resources } from "./tr";

interface IProps {
  message: string;
  values?: ITranslationValues;
  className?: string;
  onClick?: any;
  html?: boolean;
  locale: Locale;
  field?: string;
}

export default function (messages: Resources) {
  const DicoTranslate = ({
    message,
    values,
    className,
    onClick,
    html,
    locale,
    field,
  }: IProps) => {
    if (html) {
      return (
        <span
          className={className}
          onClick={onClick}
          dangerouslySetInnerHTML={{
            __html: tr(messages, locale, message, values, field),
          }}
        />
      );
    } else {
      return (
        <span className={className} onClick={onClick}>
          {tr(messages, locale, message, values, field)}
        </span>
      );
    }
  };
  return DicoTranslate;
}
